import React from 'react';
import {Box, Typography, Tooltip} from '@mui/material';
import ContentTypeIcon from "../sessions/ContentTypeIcon";

const styles = {
    box: {
        container: {
            alignItems: 'flex-start',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.1rem',
        },
        contentRow: {
            display: 'flex',
            gap: '0.5rem',
            alignItems: 'center',
        }
    },
    typography: {
        contentName: {
            fontSize: '0.875rem',
            whiteSpace: 'nowrap',
        }
    }
};

const ContentNameCell = ({contents}) => {
    if (!contents || contents.length === 0) {
        return <Typography variant="body2">-</Typography>;
    }

    return (
        <Box sx={styles.box.container}>
            {contents.map((content, index) => (
                <Box key={index} sx={styles.box.contentRow}>
                    <ContentTypeIcon contentType={content.contentType} />
                    <Tooltip title={content.name} placement="bottom">
                        <Typography variant="body2" sx={styles.typography.contentName}>
                            {content.name}
                        </Typography>
                    </Tooltip>
                </Box>
            ))}
        </Box>
    );

};

export default ContentNameCell;
